import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Link from "app/components/UI/Link";
import Modal from "app/components/UI/Modal";
import PropTypes from "prop-types";
import React from "react";
import classes from "./ModalChangeClub.module.css";
import classnames from "classnames";

export const ModalChangeClub = ({
  clubId,
  translate,
  className,
  children,
  onClose,
  onChangeClubConfirm,
  saleClubId,
  ...props
}) =>
  <Modal contentClassName={classnames(classes.modal, className)} bodyClassName={classes.modal__body} {...props}>
    <div className={classes.modal__title}>
      {translate("Désolé, vous ne pouvez pas changer de club avec un panier en cours.")}
    </div>
    <div className={classes.modal__content}>
      {children}
    </div>
    <Flex direction="row" right middle wrap className={classes.modal__actions}>
      <Link className={classes.modal__link__primary} to={formatPattern("/:clubId/checkout", { clubId: saleClubId })}>
        <Button.Flat fullWidth label={translate("Valider votre commande en cours")} primary />
      </Link>
      <Button.Flat
        className={classes.modal__action}
        onClick={onChangeClubConfirm}
        label={translate("Annuler votre panier")}
      />
    </Flex>
  </Modal>;

ModalChangeClub.propTypes = {
  translate: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  onChangeClubConfirm: PropTypes.func.isRequired,
  saleClubId: PropTypes.string.isRequired
};

export default ModalChangeClub;



// WEBPACK FOOTER //
// ./src/app/components/ModalChangeClub/ModalChangeClub.js